import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useRouteMatch } from "react-router-dom";
import moment from "moment";

import {
  Container,
  Row,
  Col,
  Table,
  Button,
  LoadingIndicator
} from "../../../components/simple";
import ModalClientUpgrade from "../../../components/complex/ModalClientUpgrade";

import Header from "../../../components/complex/Header";
import SVG from "../../../components/SVG";

import Api from "../../../api";

import styles from "./client-activities.module.scss";

const ClientActivities = () => {
  const client = useSelector(state => state.clients.data[0]);
  const isLoading = useSelector(state => state.clients.isLoading);
  const [isUpgradeModalOpen, setIsUpgradeModalOpen] = useState(false);

  const {
    params: { id }
  } = useRouteMatch("/clients/:id");

  useEffect(() => {
    // dispatch(clearClientsData())

    const getClientActivity = async () => {
      try {
        await Api.client.get({ id });
      } catch (error) {
        console.log(error);
      }
    };

    getClientActivity();
  }, [id]);

  const handleUpgrade = async () => {
    const { id: clientId, name } = client;

    await Api.client.upgrade({ id: clientId, data: { name } });
    setIsUpgradeModalOpen(false);
  };

  return (
    <Container fluid className={styles["client-activities"]}>
      <div className={styles["header-wrapper"]}>
        <Container>
          <Row>
            <Container className={styles["header-container"]}>
              <Header />
            </Container>
          </Row>

          <Row className={styles["header-overview"]}>
            <Container>
              {isLoading ? (
                <div
                  style={{
                    height: "266px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                  }}
                >
                  <LoadingIndicator />
                </div>
              ) : (
                <>
                  <Row className={styles["header-dashboard"]}>
                    <Col>
                      <div
                        className={styles["header-dashboard-title-container"]}
                      >
                        <h1 className={styles["header-dashboard-title"]}>
                          {client?.name}
                        </h1>
                        {client?.plan !== "Subscription" && !client?.sandbox ? (
                          <Button
                            className={styles["header-upgrade-btn"]}
                            onClick={() => setIsUpgradeModalOpen(true)}
                          >
                            Upgrade
                          </Button>
                        ) : null}
                      </div>
                      <p className="description" style={{ marginTop: "26px" }}>
                        A listing overview of all activities
                      </p>
                    </Col>
                  </Row>

                  <Row className={styles["header-statistics"]}>
                    <Col className={styles["header-statistics__items"]}>
                      <div className={styles["header-statistics__item"]}>
                        <span className={styles["header-statistics__number"]}>
                          {client?.statistics.activations}
                        </span>
                        Activations
                      </div>
                      <div className={styles["header-statistics__item"]}>
                        <span className={styles["header-statistics__number"]}>
                          {client?.statistics.uploads}
                        </span>
                        Uploads
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <p className={styles.description}>
                        Total Monthly activities
                      </p>
                    </Col>
                  </Row>
                </>
              )}
            </Container>
          </Row>
        </Container>
      </div>

      <Row>
        <Container>
          {/* {!isLoading && client?.audienceActivity?.length ? ( */}
          {!isLoading && client?.audienceActivity ? (
            <>
              <h5 className="mb-3">Current Month</h5>
              <Table className={styles["client-activities-table"]}>
                <thead>
                  <tr>
                    <th></th>
                    <th>Name</th>
                    <th>Activity Type</th>
                    <th>Platform</th>
                    <th>Created</th>
                  </tr>
                </thead>
                <tbody>
                  {client.audienceActivity.map(
                    ({ name, activityType, platform, createdAt }) => {
                      const parsedDate = Date.parse(createdAt);
                      const date = new Date(parsedDate);
                      const dateToShow = moment(date).format("DD.MM.YYYY");

                      // console.log(moment(createdAt, "YYYYMMDD").fromNow())

                      return (
                        <tr>
                          <th>
                            {activityType === "Activation" ? (
                              <SVG.ClientActivations width={24} height={24} />
                            ) : (
                              <SVG.ClientUpload width={24} height={24} />
                            )}
                          </th>
                          <td style={{ minWidth: "240px" }}>{name}</td>
                          <td>{activityType}</td>
                          <td>{platform || "IDFree"}</td>
                          <td>{dateToShow}</td>
                        </tr>
                      );
                    }
                  )}
                </tbody>
              </Table>
            </>
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <LoadingIndicator />
            </div>
          )}
        </Container>
      </Row>
      <ModalClientUpgrade
        isOpen={isUpgradeModalOpen}
        changeModalState={() => {
          setIsUpgradeModalOpen(prevState => !prevState);
        }}
        handleClose={() => setIsUpgradeModalOpen(false)}
        handleUpgrade={() => handleUpgrade(client)}
      />
    </Container>
  );
};

export default ClientActivities;
